import React, { useState } from 'react';

import Divider from '@mui/material/Divider';
import { useHistory } from 'react-router-dom';

import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';

import { Segment, useQueryGetSegmentsList } from 'api/queries/getSegmentsList.query';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/icon';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/components/ActivitiesSegments/ActivitiesSegments.module.scss';
import { ConfirmDeleteSegment } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/components/ActivitiesSegments/components/ConfirmDeleteSegment/ConfirmDeleteSegment';
import { CustomizedButton, CustomizedDropdownMenu, CustomizedTooltip } from 'components/common';

import { SaveSegment } from './components/SaveSegment/SaveSegment';

export const ActivitiesSegments = () => {
    const { contract } = useProjectTreeStore();
    const { version } = useVersionStore();
    const [segment, setSegment] = useState<Segment | null>(null);
    const [showModal, setShowModal] = React.useState(false);
    const { data: segments } = useQueryGetSegmentsList({ metaDataId: version?.id, contractId: contract?.id });
    const history = useHistory();

    const handleSelectSegment = (segment: Segment) => {
        history.push(segment.url);
    };

    return (
        <>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`Manage Segments`}
                        triggerElement={
                            <CustomizedButton
                                endIcon={<Icon name={'header-arrow-down'} size="1.5rem" color={'#2C8FA5'} />}
                                startIcon={<MuiIcon icon={'filter_list'} fontSize="1.5rem" color={'#2C8FA5'} />}
                                color={'secondary'}
                            >
                                Activities Segments
                            </CustomizedButton>
                        }
                    />
                }
            >
                <div className={classes.item} onClick={() => setShowModal(true)}>
                    Save Segment
                </div>
                {segments && segments?.length > 0 && <Divider />}
                {segments?.map((item) => (
                    <div key={item.segmentId} className={classes.item} onClick={() => handleSelectSegment(item)}>
                        {item.name}{' '}
                        <div
                            className={classes.icon}
                            onClick={(e) => {
                                e.stopPropagation();
                                setSegment(item);
                            }}
                        >
                            <MuiIcon icon={'close_small'} color={'#cc0000'} />
                        </div>
                    </div>
                ))}
            </CustomizedDropdownMenu>

            <SaveSegment isShowModal={showModal} handleModalClose={() => setShowModal(false)} />

            <ConfirmDeleteSegment segment={segment} handleModalClose={() => setSegment(null)} />
        </>
    );
};
